export default "/images/_Produkte.webp?e1d59a640a3632906e1531642a7579da";